import { render } from "./WarningContainer.vue?vue&type=template&id=39e88755&scoped=true"
import script from "./WarningContainer.vue?vue&type=script&lang=js"
export * from "./WarningContainer.vue?vue&type=script&lang=js"

import "./WarningContainer.vue?vue&type=style&index=0&id=39e88755&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e88755"]])

export default __exports__